/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestOptions
 */
export interface RequestOptions {
    /**
     * 
     * @type {number}
     * @memberof RequestOptions
     */
    newLinesAfterRequest?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RequestOptions
     */
    includeIntroduction?: boolean | null;
}

export function RequestOptionsFromJSON(json: any): RequestOptions {
    return RequestOptionsFromJSONTyped(json, false);
}

export function RequestOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newLinesAfterRequest': !exists(json, 'newLinesAfterRequest') ? undefined : json['newLinesAfterRequest'],
        'includeIntroduction': !exists(json, 'includeIntroduction') ? undefined : json['includeIntroduction'],
    };
}

export function RequestOptionsToJSON(value?: RequestOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newLinesAfterRequest': value.newLinesAfterRequest,
        'includeIntroduction': value.includeIntroduction,
    };
}


